import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/pan.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  alt: "Pan",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!
  const _component_Timer = _resolveComponent("Timer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_HelloWorld, { msg: "Days to Work At balance!!!!!!!!" }),
    _createVNode(_component_Timer)
  ], 64))
}